<script>
import moment from 'moment';

export default {
  name: 'CpActivityCard',
  components: {
    capitalizeWords: require('../../mixins/utils.js').default,
    CpOriginalPost: require('./OriginalPost').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
    marginTop: require('../../directives/margins').marginTop,
    marginLeft: require('../../directives/margins').marginLeft,
    marginRight: require('../../directives/margins').marginRight,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      createdAt: moment(this.item.created_at).fromNow(),
      permalink: this.item.post_permalink ?? this.item.permalink,
      profileImage: this.item.owner.profile_image,
      actionText: this.item.action_text ?? this.item.action,
      postTitle: !this.item?.politician ? this.item?.post_title : this.item.politician?.full_name ?? '',
      username: this.item.owner.name,
      isOpenCard: this.index < 3,
      resultsUrlSuffix: '',
    };
  },
  computed: {
    isOfficial() {
      return this.item.post_type === 'official';
    },
  },
  methods: {
    handleOpenCard() {
      this.isOpenCard = !this.isOpenCard;
    },
  },
};
</script>

<template>
  <div>
    <span :class="{ yourActivityContainer: true, disabled: isOfficial }" @click.stop="!isOfficial && handleOpenCard()">
      <div class="textContainer">
        <span v-if="!isOfficial" v-margin-right="0.5">
          <i v-if="isOpenCard" class="fal fa-chevron-up fa-1-5x primary6-color"></i>
          <i v-else class="fal fa-chevron-down fa-1-5x primary6-color"></i>
        </span>
        <img :src="profileImage" width="24" height="24" class="image" />
        <p class="subheadline2 black-color notBtnStyles">
          {{ capitalizeWords(username) }} <span class="footnote">{{ actionText }}</span
          >&nbsp;{{ postTitle }}
        </p>
      </div>
      <p v-if="item.created_at" class="caption2 primary-color">
        {{ createdAt }}
      </p>
    </span>
    <div v-if="isOpenCard" class="originalPostContainer">
      <div class="originalPost">
        <CpOriginalPost :post="item" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.yourActivityContainer,
.textContainer {
  display: flex;
  align-items: center;
}

.yourActivityContainer {
  justify-content: space-between;
  padding: 0px 8px;
  border: 1px solid var(--neutral2);
  border-radius: 8px;
  margin-bottom: 8px;
  min-height: 56px;
  cursor: pointer;
}

.yourActivityContainer:hover {
  background-color: var(--primary1);
}

.disabled {
  cursor: default;
}

.disabled:hover {
  background-color: var(--white);
}

.image {
  margin-right: 10px;
  border-radius: 50%;
}

.notBtnStyles {
  background-color: unset;
  border: 0;
  padding: 0 2px;
}

.originalPostContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--primary-blue-50);
  margin-bottom: 8px;
  padding-left: 20px;
}

.originalPost {
  max-width: 75%;
}
</style>
